import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IUserActionResult } from '../types/IUserActionResult';

export interface ICreateLocalUserSiteSamlParams {
  username: string;           // name for new user; required, not empty; expected to be unique on server
  displayName: string;        // display or friendly name; required, not empty
  email: string;              // user email; not required
  authSetting: string;        // AuthType; should be SAML
  admin?: boolean;            // true to make the new user a server admin (optional, mutually exclusive with 'siteRole')
  siteRole?: string;          // site role for new user (optional, mutually exclusive with 'admin')  
}

export class CreateLocalUserWithSiteSamlAuthRequest extends Request<ICreateLocalUserSiteSamlParams, IUserActionResult> {
  constructor(params: ICreateLocalUserSiteSamlParams) {
    super('createLocalUserWithSiteSamlAuth', params);
  }
}
